<script setup>
// One labelled detail on the Your details page. Anything else given (type,
// autocomplete, placeholder, inputmode, disabled) goes to the box itself.
defineOptions({ inheritAttrs: false });

defineProps({
  label: { type: String, required: true },
  hint: { type: String, default: "" },
  modelValue: { type: String, default: "" },
  multiline: { type: Boolean, default: false },
});
defineEmits(["update:modelValue"]);

const id = `detail-${crypto.randomUUID()}`;
</script>

<template>
  <div>
    <label :for="id" class="block text-sm font-bold text-primary">{{
      label
    }}</label>
    <p v-if="hint" :id="`${id}-hint`" class="text-xs text-secondary">
      {{ hint }}
    </p>
    <component
      :is="multiline ? 'textarea' : 'input'"
      :id="id"
      :value="modelValue"
      :aria-describedby="hint ? `${id}-hint` : undefined"
      class="mt-1.5 block w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-base text-primary transition-colors placeholder:text-secondaryLight focus:border-accentPrimary focus:outline-none focus:ring-1 focus:ring-accentPrimary disabled:opacity-60"
      :class="{ 'min-h-[7.5rem] resize-y': multiline }"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>
